import { render, staticRenderFns } from "./store-card.vue?vue&type=template&id=58b6d472&"
import script from "./store-card.vue?vue&type=script&lang=js&"
export * from "./store-card.vue?vue&type=script&lang=js&"
import style0 from "./store-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports